import { DatePipe, formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-contract-indetail-report',
  templateUrl: './contract-indetail-report.component.html',
  styleUrl: './contract-indetail-report.component.scss'
})
export class ContractIndetailReportComponent {

  contractData: any[] = [];
  filteredcontractData: any[] = [];
  contractsData: any[] = [];
  issueDates: any[] = [];
  monthGroups: any = {};
  indetailsData: any[] = [];
  reportType = '';
  totalData = {
    contract_prev_bal: 0,
    remaining_contract: 0,
    contract_amt: 0,
    contract_discnt_amt: 0,
    contract_net_amt: 0,
    contract_net_gst_amt: 0,
    contract_net_total: 0,
    total_march_end: 0,
    next_year: 0,
    till_date_used: 0,
    use_till_march_end: 0,
  };

  groupColors = [
    'rgb(120, 218, 233)', 'rgb(255, 200, 200)', 'rgb(200, 255, 200)',
    'rgb(255, 230, 180)', 'rgb(230, 200, 255)', 'rgb(255, 255, 180)',
    'rgb(200, 230, 255)', 'rgb(255, 220, 230)', 'rgb(220, 255, 220)',
    'rgb(255, 240, 200)', 'rgb(255, 210, 160)', 'rgb(210, 240, 255)',
    'rgb(240, 210, 255)', 'rgb(255, 255, 210)', 'rgb(210, 255, 240)',
  ];

  advtColorMap: { [key: string]: string } = {};

  today: any;
  nexttoday: any;
  totalweeks = 0;

  selectedYear!: number;
  years: number[] = [];

  startDate: any = '';
  endDate: any = '';
  repName = '';
  offRepName = '';
  advtName = '';

  lastcontract: number = 0;
  remaincontract: number = 0;
  newcontract: number = 0;
  agencydiscontract: number = 0;
  totalcontract: number = 0;
  gstcontract: number = 0;
  grandtotalcontract: number = 0;

  constructor(
    private dialogRef: MatDialogRef<ContractIndetailReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.initializeYears();
    this.initializeData();
    if (this.reportType !== 'indetail' && this.reportType !== 'indetailcontract') {
      this.getContractDetails();
    }
    this.calculatetotalweeks();
  }

  initializeYears() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    for (let year = 2020; year <= currentYear + 2; year++) {
      this.years.push(year);
    }
  }

  getFiscalYearFromDate(dateString: string): any {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth();
    if (month < 3) return year - 1;
    return year;
  }

  updateDatesForYear() {
    this.today = new Date(this.selectedYear, 3, 1);
    this.nexttoday = new Date(this.selectedYear + 1, 3, 1);
    this.startDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.endDate = this.datePipe.transform(new Date(this.selectedYear + 1, 2, 31), 'yyyy-MM-dd');
    this.calculatetotalweeks();
  }

  onYearChange() {
    this.updateDatesForYear();
    if (this.reportType == 'indetail' || this.reportType == 'indetailcontract') {
      this.getIndetailsContractDetails();
    } else {
      this.filterData();
    }
    this.cdr.detectChanges();
  }

  initializeData() {
    this.reportType = this.data['reportType'];
    const dialogStartDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    const dialogEndDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];

    if (dialogStartDate && dialogEndDate) {
      this.startDate = dialogStartDate;
      this.endDate = dialogEndDate;
      this.selectedYear = this.getFiscalYearFromDate(dialogStartDate);
      this.today = new Date(this.selectedYear, 3, 1);
      this.nexttoday = new Date(this.selectedYear + 1, 3, 1);
    } else {
      const currentDate = new Date();
      this.selectedYear = currentDate.getMonth() >= 3 ? currentDate.getFullYear() : currentDate.getFullYear() - 1;
      this.updateDatesForYear();
    }

    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];

    if (this.reportType == 'indetail' || this.reportType == 'indetailcontract') {
      this.getIndetailsContractDetails();
    } else {
      this.contractData = this.data['contractData'] || [];
      this.filterData();
    }
  }

  getContractDetails() {
    this.service.getAllContractDetails().subscribe((res) => {
      this.contractData = res;
      this.calculateContractTotals();
    });
  }

  calculateContractTotals() {
    this.lastcontract = 0;
    this.remaincontract = 0;
    this.newcontract = 0;
    this.agencydiscontract = 0;
    this.totalcontract = 0;
    this.gstcontract = 0;
    this.grandtotalcontract = 0;

    if (!Array.isArray(this.contractData)) return;

    for (let data1 of this.contractData) {
      this.lastcontract += Number(data1.contract_prev_bal) || 0;
      this.newcontract += Number(data1.contract_amt) || 0;
      this.agencydiscontract += Number(data1.contract_discnt_amt) || 0;
      this.totalcontract += Number(data1.contract_net_amt) || 0;
      this.gstcontract += Number(data1.contract_net_gst_amt) || 0;
      this.grandtotalcontract += Number(data1.contract_net_total) || 0;
    }
  }

  getIndetailsContractDetails() {
    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.advtName,
      "fiscal_year": this.selectedYear
    };

    console.log('Request payload:', req);

    this.service.getAllIndetailsContractDetails(req).subscribe((response: any) => {
      console.log('API Response:', response);

      this.issueDates = response.issue_dates || [];
      this.monthGroups = response.month_groups || {};
      this.contractsData = response.contracts || [];

      const existingContractNos = new Set(
        this.contractsData.map((c: any) => c.contract_no)
      );

      this.service.getAllContractDetails().subscribe((res: any) => {
        const allContracts: any[] = res?.data || [];

        const yearStart = new Date(this.selectedYear, 3, 1);
        const yearEnd   = new Date(this.selectedYear + 1, 2, 31);

        const noBookingContracts = allContracts.filter((c: any) => {
          if (existingContractNos.has(c.contract_no)) return false;

          const fromDate = c.contract_period_from ? new Date(c.contract_period_from) : null;
          const toDate   = c.contract_period_to   ? new Date(c.contract_period_to)   : null;

          const inYear =
            (fromDate && fromDate >= yearStart && fromDate <= yearEnd) ||
            (toDate   && toDate   >= yearStart && toDate   <= yearEnd) ||
            (fromDate && toDate   && fromDate  <= yearStart && toDate >= yearEnd);

          if (!inYear) return false;

          if (this.repName    && this.repName    !== '' && !this.repName.includes(c.rep_name))       return false;
          if (this.offRepName && this.offRepName !== '' && !this.offRepName.includes(c.off_rep_name)) return false;
          if (this.advtName   && this.advtName   !== '' && this.advtName !== c.advt_name)             return false;

          return true;
        });

        for (const c of noBookingContracts) {
          this.contractsData.push({
            contract_id:            c.contract_id,
            contract_no:            c.contract_no,
            contract_date:          c.contract_date,
            rep_name:               c.rep_name,
            off_rep_name:           c.off_rep_name,
            advt_name:              c.advt_name || c.cust_name || '',
            cust_name:              c.advt_name || c.cust_name || '',
            contract_prev_bal:      c.contract_prev_bal      || 0,
            contract_amt:           c.contract_amt           || 0,
            contract_discnt_amt:    c.contract_discnt_amt    || 0,
            contract_net_amt:       c.contract_net_amt       || 0,
            contract_net_gst_amt:   c.contract_net_gst_amt   || 0,
            contract_net_total:     c.contract_net_total     || 0,
            contract_period_from:   c.contract_period_from,
            contract_period_to:     c.contract_period_to,
            contract_bkng_advt_amt: c.contract_bkng_advt_amt || 0,
            contract_bal_amt:       c.contract_bal_amt       || 0,
            instruction:            c.instruction,
            gst_include_exclude:    c.gst_include_exclude,
            // ✅ KEY FIX: Use backend's till_date_used for aaj_akher_vaprle
            // This is 0 when no invoice created — correct!
            aaj_akher_vaprle:       parseFloat(c.till_date_used) || 0,
            bookings:               []
          });
        }

        this.contractData = Array.isArray(this.contractsData)
          ? this.convertToOldFormat(this.contractsData)
          : [];

        this.filteredcontractData = this.contractData;
        this.calculateTotal();
        this.getData();
      });
    });
  }

  convertToOldFormat(contracts: any) {
    let oldFormatData = [];
    for (let contract of contracts) {
      if (contract.bookings && contract.bookings.length > 0) {
        for (let booking of contract.bookings) {
          oldFormatData.push({
            ...booking,
            contract_id:            contract.contract_id,
            contract_no:            contract.contract_no,
            contract_date:          contract.contract_date,
            contract_prev_bal:      contract.contract_prev_bal || 0,
            contract_amt:           contract.contract_amt,
            contract_discnt_amt:    contract.contract_discnt_amt,
            contract_net_amt:       contract.contract_net_amt,
            contract_net_gst_amt:   contract.contract_net_gst_amt,
            contract_net_total:     contract.contract_net_total,
            contract_period_from:   contract.contract_period_from,
            contract_period_to:     contract.contract_period_to,
            contract_bkng_advt_amt: contract.contract_bkng_advt_amt,
            contract_bal_amt:       contract.contract_bal_amt,
            instruction:            contract.instruction,
            cust_name:              contract.cust_name,
            gst_include_exclude:    contract.gst_include_exclude,
            _issue_wise_amount:     contract.issue_wise_amount,
            _month_wise_total:      contract.month_wise_total,
            // ✅ aaj_akher_vaprle comes from backend (real invoice paid amount)
            aaj_akher_vaprle:       parseFloat(contract.aaj_akher_vaprle) || 0,
          });
        }
      } else {
        // No bookings — push contract row with 0 paid amount
        oldFormatData.push({
          contract_id:            contract.contract_id,
          contract_no:            contract.contract_no,
          contract_date:          contract.contract_date,
          contract_prev_bal:      contract.contract_prev_bal || 0,
          contract_amt:           contract.contract_amt,
          contract_discnt_amt:    contract.contract_discnt_amt,
          contract_net_amt:       contract.contract_net_amt,
          contract_net_gst_amt:   contract.contract_net_gst_amt,
          contract_net_total:     contract.contract_net_total,
          contract_period_from:   contract.contract_period_from,
          contract_period_to:     contract.contract_period_to,
          contract_bkng_advt_amt: contract.contract_bkng_advt_amt,
          contract_bal_amt:       contract.contract_bal_amt,
          instruction:            contract.instruction,
          cust_name:              contract.cust_name,
          gst_include_exclude:    contract.gst_include_exclude,
          _issue_wise_amount:     contract.issue_wise_amount,
          _month_wise_total:      contract.month_wise_total,
          // ✅ No invoice created → 0 (correct!)
          aaj_akher_vaprle:       parseFloat(contract.aaj_akher_vaprle) || 0,
          advt_name:              contract.advt_name || contract.cust_name || '',
          rep_name:               contract.rep_name  || '',
          off_rep_name:           contract.off_rep_name || '',
          issue_date: '', issue_name: '', amount: 0, pages_no: '',
          page_no: '', size: '', booking_no: '', booking_date: '',
          advt_amt: 0, advt_discnt: 0, cgst: 0, sgst: 0, igst: 0,
          DS_ADVTID: '', rep_mob_no: '', sub_id: '',
          sub_gst_include_exclude: '', total_amount: 0,
          is_no_booking: true
        });
      }
    }
    return oldFormatData;
  }

  calculatetotalweeks() {
    this.totalweeks = 0;
    for (let index = 0; index < 12; index++) {
      if (index < 3) {
        this.totalweeks += this.sundays(formatDate(this.nexttoday, 'yyyy', 'en-IN', 'GMT+0530'), index);
      } else {
        this.totalweeks += this.sundays(formatDate(this.today, 'yyyy', 'en-IN', 'GMT+0530'), index);
      }
    }
  }

  firstSunday(month: any, year: any) {
    let tempDate = new Date();
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setMonth(month);
    tempDate.setFullYear(year);
    tempDate.setDate(1);
    let day = tempDate.getDay();
    let toNextSun = day !== 0 ? 7 - day : 0;
    tempDate.setDate(tempDate.getDate() + toNextSun);
    return tempDate;
  }

  secondSunday(month: any, year: any) {
    let tempDate = new Date(this.firstSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);
    return tempDate;
  }

  thirdSunday(month: any, year: any) {
    let tempDate = new Date(this.secondSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);
    return tempDate;
  }

  fourthSunday(month: any, year: any) {
    let tempDate = new Date(this.thirdSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);
    return tempDate;
  }

  fifthSunday(month: any, year: any) {
    let tempDate = new Date(this.fourthSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);
    // Check if 5th Sunday is still in the same month
    if (tempDate.getMonth() !== month) return null;
    return tempDate;
  }

  sundays(year: any, month: any) {
    let day = 1, counter = 0;
    let date = new Date(year, month, day);
    while (date.getMonth() === month) {
      if (date.getDay() === 0) counter++;
      day++;
      date = new Date(year, month, day);
    }
    return counter;
  }

  filterData() {
    if (!this.contractData || !Array.isArray(this.contractData)) {
      this.filteredcontractData = [];
      return;
    }

    if (!this.startDate && !this.endDate && !this.repName && !this.offRepName && !this.advtName) {
      this.filteredcontractData = this.contractData;
    } else {
      this.filteredcontractData = this.contractData.filter((a: any) => {
        let match = true;
        if (this.startDate && this.endDate) {
          match = match && a['contract_date'] >= this.startDate && a['contract_date'] <= this.endDate;
        }
        if (this.repName)    match = match && this.repName.includes(a['rep_name']);
        if (this.offRepName) match = match && this.offRepName.includes(a['off_rep_name']);
        if (this.advtName)   match = match && this.advtName === a['advt_name'];
        return match;
      });
    }
    this.calculateTotal();
  }

  calculateTotal() {
    this.totalData = {
      contract_prev_bal: 0, remaining_contract: 0, contract_amt: 0,
      contract_discnt_amt: 0, contract_net_amt: 0, contract_net_gst_amt: 0,
      contract_net_total: 0, total_march_end: 0, next_year: 0,
      till_date_used: 0, use_till_march_end: 0,
    };

    for (let index = 0; index < this.filteredcontractData.length; index++) {
      this.totalData['contract_prev_bal']   += parseFloat(this.filteredcontractData[index]['contract_prev_bal'])   || 0;
      this.totalData['contract_amt']        += parseFloat(this.filteredcontractData[index]['contract_amt'])        || 0;
      this.totalData['contract_discnt_amt'] += parseFloat(this.filteredcontractData[index]['contract_discnt_amt']) || 0;
      this.totalData['contract_net_amt']    += parseFloat(this.filteredcontractData[index]['contract_net_amt'])    || 0;
      this.totalData['contract_net_gst_amt']+= parseFloat(this.filteredcontractData[index]['contract_net_gst_amt'])|| 0;
      this.totalData['contract_net_total']  += parseFloat(this.filteredcontractData[index]['contract_net_total'])  || 0;
    }
  }

  buildAdvtColorMap() {
    this.advtColorMap = {};
    let colorIndex = 0;
    let contractGroups: any = {};
    for (let item of this.filteredcontractData) {
      if (!contractGroups[item.contract_no]) {
        contractGroups[item.contract_no] = item.advt_name || item.cust_name || '';
      }
    }
    for (let contractNo in contractGroups) {
      const advtName = contractGroups[contractNo];
      if (advtName && !(advtName in this.advtColorMap)) {
        this.advtColorMap[advtName] = this.groupColors[colorIndex % this.groupColors.length];
        colorIndex++;
      }
    }
  }

  getAdvtColor(advtName: string): string {
    return this.advtColorMap[advtName] || 'rgb(255, 255, 255)';
  }

  getGroupColor(index: number): string {
    return 'rgb(220, 220, 220)';
  }

  buildContractDataObject(item: any, issueWiseAmount = {}) {
    const baseObject = {
      DS_ADVTID:              item['DS_ADVTID'],
      advt_amt:               item['advt_amt'],
      advt_discnt:            item['advt_discnt'],
      advt_name:              item['advt_name'] || item['cust_name'] || '',
      amount:                 item['amount'],
      booking_date:           item['booking_date'],
      booking_no:             item['booking_no'],
      cgst:                   item['cgst'],
      contract_amt:           item['contract_amt'],
      contract_bal_amt:       item['contract_bal_amt'],
      contract_bkng_advt_amt: item['contract_bkng_advt_amt'],
      contract_date:          item['contract_date'],
      contract_discnt_amt:    item['contract_discnt_amt'],
      contract_id:            item['contract_id'],
      contract_net_amt:       item['contract_net_amt'],
      contract_net_gst_amt:   item['contract_net_gst_amt'],
      contract_net_total:     item['contract_net_total'],
      contract_no:            item['contract_no'],
      contract_period_from:   item['contract_period_from'],
      contract_period_to:     item['contract_period_to'],
      contract_prev_bal:      item['contract_prev_bal'],
      cust_name:              item['cust_name'],
      gst_include_exclude:    item['gst_include_exclude'],
      igst:                   item['igst'],
      instruction:            item['instruction'],
      issue_date:             item['issue_date'] || '',
      issue_name:             item['issue_name'] || '',
      off_rep_name:           item['off_rep_name'],
      page_no:                item['page_no'],
      pages_no:               item['pages_no'],
      rep_mob_no:             item['rep_mob_no'],
      rep_name:               item['rep_name'],
      sgst:                   item['sgst'],
      size:                   item['size'],
      sub_gst_include_exclude:item['sub_gst_include_exclude'],
      sub_id:                 item['sub_id'],
      total_amount:           item['amount'],
      // ✅ KEY FIX: Always carry aaj_akher_vaprle from backend — never recalculate from dates
      aaj_akher_vaprle:       parseFloat(item['aaj_akher_vaprle']) || 0,
      is_no_booking:          item['is_no_booking'] || false,
    };

    const weekData = this.mapBookingsToWeeks(item);
    return { ...baseObject, ...weekData };
  }

  getWeekInfoFromDate(dateStr: any) {
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;

    const day   = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1;
    const year  = parseInt('20' + parts[2]);
    const date  = new Date(year, month, day);

    const monthNames = ['january', 'feb', 'march', 'april', 'may', 'june',
                        'july', 'august', 'september', 'october', 'november', 'december'];
    const week = this.getWeekNumber(date, month, year);

    return { month: monthNames[month], week };
  }

  getWeekNumber(date: any, month: any, year: any) {
    const weeks = [
      this.firstSunday(month, year),  this.secondSunday(month, year),
      this.thirdSunday(month, year),  this.fourthSunday(month, year),
      this.fifthSunday(month, year)
    ];
    const dateStr = this.formattedDate(date);
    for (let i = 0; i < weeks.length; i++) {
      if (weeks[i] && dateStr === this.formattedDate(weeks[i])) return i + 1;
    }
    return 1;
  }

  getWeekValue(item: any, month: any, weekNumber: any, field: any, isNextYear = false) {
    let date;
    const year = isNextYear
      ? formatDate(this.nexttoday, 'yyyy', 'en-IN', 'GMT+0530')
      : formatDate(this.today,    'yyyy', 'en-IN', 'GMT+0530');

    switch (weekNumber) {
      case 1: date = this.firstSunday(month, year);  break;
      case 2: date = this.secondSunday(month, year); break;
      case 3: date = this.thirdSunday(month, year);  break;
      case 4: date = this.fourthSunday(month, year); break;
      case 5: date = this.fifthSunday(month, year);  break;
    }

    return this.formattedDate(date) == item['issue_date'].split(',')[0] ? item[field] : '';
  }

  formatYear(date: any) {
    return formatDate(date, 'yyyy', 'en-IN', 'GMT+0530');
  }

  formattedDate(date: any) {
    return formatDate(date, 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
  }

  uniqueData(data: any, key: any) {
    return [...new Map(data.map((a: any) => [key(a), a])).values()];
  }

  calculateTotalAmount(...args: any) {
    return args.reduce((acc: any, curr: any) => {
      let a = curr == '' ? 0 : parseFloat(curr);
      return acc + a;
    }, 0);
  }

  mapBookingsToWeeks(contractItem: any) {
    const weekData: any = {};
    const months = ['april', 'may', 'june', 'july', 'august', 'september',
                    'october', 'november', 'december', 'january', 'feb', 'march'];

    for (let monthName of months) {
      for (let week = 1; week <= 5; week++) {
        const weekNum = week === 1 ? '1st' : week === 2 ? '2nd' : week === 3 ? '3rd' : week === 4 ? '4th' : '5th';
        weekData[`${monthName}${weekNum}WeekAmt`]       = 0;
        weekData[`${monthName}${weekNum}WeekSize`]      = '';
        weekData[`${monthName}${weekNum}WeekPageNo`]    = '';
        weekData[`${monthName}${weekNum}WeekIssueName`] = '';
      }
    }

    const contractData = this.contractsData.find(c => c.contract_no === contractItem.contract_no);

    if (contractData && contractData.bookings) {
      for (let booking of contractData.bookings) {
        const weekInfo = this.getWeekInfoFromDate(booking.issue_date);
        if (weekInfo) {
          const { month, week } = weekInfo;
          const weekNum = week === 1 ? '1st' : week === 2 ? '2nd' : week === 3 ? '3rd' : week === 4 ? '4th' : '5th';

          const existing = parseFloat(weekData[`${month}${weekNum}WeekAmt`] || 0);
          weekData[`${month}${weekNum}WeekAmt`] = existing + parseFloat(booking.amount || 0);

          if (!weekData[`${month}${weekNum}WeekIssueName`])
            weekData[`${month}${weekNum}WeekIssueName`] = booking.size || '';
          if (!weekData[`${month}${weekNum}WeekPageNo`])
            weekData[`${month}${weekNum}WeekPageNo`] = booking.pages_no || '';
          if (!weekData[`${month}${weekNum}WeekSize`])
            weekData[`${month}${weekNum}WeekSize`] = booking.size || '';
        }
      }
    }

    for (let monthName of months) {
      for (let week = 1; week <= 5; week++) {
        const weekNum = week === 1 ? '1st' : week === 2 ? '2nd' : week === 3 ? '3rd' : week === 4 ? '4th' : '5th';
        const amt = weekData[`${monthName}${weekNum}WeekAmt`];
        weekData[`${monthName}${weekNum}WeekAmt`] = (amt === 0) ? '' : String(amt);
      }
    }

    return weekData;
  }

  formatWholeNumber(amount: string | number): string {
    if (!amount) return '';
    const cleanedAmount = parseFloat(String(amount).replace(/,/g, ''));
    const roundedAmount = Math.round(cleanedAmount);
    return roundedAmount === 0 ? '' : String(roundedAmount);
  }

  calculateTotalWithPrevBal(prevBal: any, netTotal: any): number {
    return (parseFloat(prevBal) || 0) + (parseFloat(netTotal) || 0);
  }

  getData() {
    this.indetailsData = [];

    if (!this.filteredcontractData || !Array.isArray(this.filteredcontractData) || this.filteredcontractData.length === 0) {
      this.cdr.detectChanges();
      this.refreshGrandTotals();
      return;
    }

    this.buildAdvtColorMap();

    const uniqueRepNames: string[] = [];
    for (const item of this.filteredcontractData) {
      if (!item) continue;
      const repName = (item.off_rep_name || item.rep_name || '').toString().trim();
      if (repName && !uniqueRepNames.includes(repName)) uniqueRepNames.push(repName);
    }

    if (uniqueRepNames.length === 0) {
      this.cdr.detectChanges();
      return;
    }

    const result: any[] = [];

    for (const groupRepName of uniqueRepNames) {
      if (!groupRepName) continue;

      const commonData = this.filteredcontractData.filter((a) => {
        if (!a) return false;
        const repName = (a.off_rep_name || a.rep_name || '').toString().trim();
        return repName === groupRepName;
      });

      const advtGroups: { [key: string]: any[] } = {};
      for (const item of commonData) {
        if (!item) continue;
        const advtName = (item.advt_name || item.cust_name || '').toString().trim();
        if (!advtGroups[advtName]) advtGroups[advtName] = [];
        const alreadyAdded = advtGroups[advtName].find(
          x => (x.contract_no || x.contract_id) === (item.contract_no || item.contract_id)
        );
        if (!alreadyAdded) advtGroups[advtName].push(item);
      }

      const sortedDataCommon: any[] = [];
      let contract_prev_bal = 0, contract_amt = 0, contract_discnt_amt = 0;
      let contract_net_amt = 0, contract_net_gst_amt = 0, contract_net_total = 0;
      let remaining_contract = 0;

      for (const advtName in advtGroups) {
        const contracts = advtGroups[advtName];

        if (contracts.length === 1) {
          const item = contracts[0];
          const isPrevContract = item.is_previous_contract === true;

          if (isPrevContract) {
            contract_prev_bal += parseFloat(item['contract_prev_bal']) || 0;
          } else {
            contract_prev_bal    += parseFloat(item['contract_prev_bal'])    || 0;
            contract_amt         += parseFloat(item['contract_amt'])         || 0;
            contract_discnt_amt  += parseFloat(item['contract_discnt_amt'])  || 0;
            contract_net_amt     += parseFloat(item['contract_net_amt'])     || 0;
            contract_net_gst_amt += parseFloat(item['contract_net_gst_amt']) || 0;
            contract_net_total   += parseFloat(item['contract_net_total'])   || 0;
          }
          remaining_contract += parseFloat(item['contract_bal_amt']) || 0;

          const built = this.buildContractDataObject(item);
          if (built) {
            built['is_previous_contract'] = isPrevContract;
            if (!built['advt_name']) built['advt_name'] = item['cust_name'] || '';
            sortedDataCommon.push(built);
          }
        } else {
          const merged = this.mergeContractsForSameAdvt(contracts);
          contract_prev_bal    += parseFloat(merged['contract_prev_bal'])    || 0;
          contract_amt         += parseFloat(merged['contract_amt'])         || 0;
          contract_discnt_amt  += parseFloat(merged['contract_discnt_amt'])  || 0;
          contract_net_amt     += parseFloat(merged['contract_net_amt'])     || 0;
          contract_net_gst_amt += parseFloat(merged['contract_net_gst_amt']) || 0;
          contract_net_total   += parseFloat(merged['contract_net_total'])   || 0;
          remaining_contract   += parseFloat(merged['contract_bal_amt'])     || 0;

          const built = this.buildMergedContractDataObject(merged, contracts);
          if (built) sortedDataCommon.push(built);
        }
      }

      if (sortedDataCommon.length > 0) {
        result.push({
          name: groupRepName,
          data: sortedDataCommon,
          contract_prev_bal, remaining_contract,
          contract_amt, contract_discnt_amt,
          contract_net_amt, contract_net_gst_amt, contract_net_total,
        });
      }
    }

    this.indetailsData = result.filter(g => g && g.name && Array.isArray(g.data));
    this.refreshGrandTotals();
    this.cdr.detectChanges();
  }

  mergeContractsForSameAdvt(contracts: any[]): any {
    const sorted = [...contracts].sort((a, b) => {
      const dateA = new Date(a.contract_period_from || 0).getTime();
      const dateB = new Date(b.contract_period_from || 0).getTime();
      return dateA - dateB;
    });

    const newContract = { ...sorted[sorted.length - 1] };

    let totalPrevBal = 0;
    for (let i = 0; i < sorted.length - 1; i++) {
      totalPrevBal += (parseFloat(sorted[i]['contract_prev_bal']) || 0)
                    + (parseFloat(sorted[i]['contract_net_total']) || 0);
    }
    totalPrevBal += parseFloat(newContract['contract_prev_bal']) || 0;

    // ✅ Sum aaj_akher_vaprle from ALL merged contracts (backend value)
    const totalPaid = sorted.reduce((sum, c) => sum + (parseFloat(c['aaj_akher_vaprle']) || 0), 0);

    const allPeriods = sorted.map(c => ({ from: c.contract_period_from, to: c.contract_period_to }));

    return {
      ...newContract,
      contract_prev_bal:    totalPrevBal,
      contract_period_from: sorted[0].contract_period_from,
      contract_period_to:   sorted[sorted.length - 1].contract_period_to,
      _all_periods:         allPeriods,
      _merged_contracts:    sorted,
      // ✅ Keep merged paid amount
      aaj_akher_vaprle:     totalPaid,
    };
  }

  buildMergedContractDataObject(mergedItem: any, contracts: any[]): any {
    const baseObject = this.buildContractDataObject(mergedItem);
    baseObject['_all_periods'] = mergedItem['_all_periods'] || [];

    const months = ['april', 'may', 'june', 'july', 'august', 'september',
                    'october', 'november', 'december', 'january', 'feb', 'march'];

    for (const monthName of months) {
      for (let week = 1; week <= 5; week++) {
        const weekNum = week === 1 ? '1st' : week === 2 ? '2nd' : week === 3 ? '3rd' : week === 4 ? '4th' : '5th';
        baseObject[`${monthName}${weekNum}WeekAmt`]       = 0;
        baseObject[`${monthName}${weekNum}WeekPageNo`]    = '';
        baseObject[`${monthName}${weekNum}WeekIssueName`] = '';
        baseObject[`${monthName}${weekNum}WeekSize`]      = '';
      }
    }

    for (const contract of contracts) {
      const contractInData = this.contractsData.find((c: any) => c.contract_no === contract.contract_no);
      if (contractInData && contractInData.bookings) {
        for (const booking of contractInData.bookings) {
          const weekInfo = this.getWeekInfoFromDate(booking.issue_date);
          if (weekInfo) {
            const { month, week } = weekInfo;
            const weekNum = week === 1 ? '1st' : week === 2 ? '2nd' : week === 3 ? '3rd' : week === 4 ? '4th' : '5th';
            const existing = parseFloat(baseObject[`${month}${weekNum}WeekAmt`] || 0);
            baseObject[`${month}${weekNum}WeekAmt`] = existing + parseFloat(booking.amount || 0);
            if (!baseObject[`${month}${weekNum}WeekIssueName`])
              baseObject[`${month}${weekNum}WeekIssueName`] = booking.size || '';
            if (!baseObject[`${month}${weekNum}WeekPageNo`])
              baseObject[`${month}${weekNum}WeekPageNo`] = booking.pages_no || '';
          }
        }
      }
    }

    for (const monthName of months) {
      for (let week = 1; week <= 5; week++) {
        const weekNum = week === 1 ? '1st' : week === 2 ? '2nd' : week === 3 ? '3rd' : week === 4 ? '4th' : '5th';
        const amt = baseObject[`${monthName}${weekNum}WeekAmt`];
        baseObject[`${monthName}${weekNum}WeekAmt`] = (amt === 0 || amt === '') ? '' : String(amt);
      }
    }

    return baseObject;
  }

  calculateGroupMonthTotal(group: any, month: string): number {
    let total = 0;
    for (const data of group.data) {
      for (let w = 1; w <= 5; w++) {
        const weekNum = w === 1 ? '1st' : w === 2 ? '2nd' : w === 3 ? '3rd' : w === 4 ? '4th' : '5th';
        total += parseFloat(data[`${month}${weekNum}WeekAmt`]) || 0;
      }
    }
    return total || 0;
  }

  getMonthTotal(month: string): number {
    let total = 0;
    this.indetailsData.forEach(group => {
      group.data.forEach((item: any) => {
        for (let w = 1; w <= 5; w++) {
          const weekNum = w === 1 ? '1st' : w === 2 ? '2nd' : w === 3 ? '3rd' : w === 4 ? '4th' : '5th';
          total += parseFloat(item[`${month}${weekNum}WeekAmt`]) || 0;
        }
      });
    });
    return total;
  }

  exportExcel(fileName: any): void {
    let element = document.getElementById('print-section');
    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }
    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook  = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, fileName + '_' + this.selectedYear + '-' + (this.selectedYear + 1) + '.xlsx');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  _grandTotalsCache: any = null;

  refreshGrandTotals() {
    this._grandTotalsCache = null;
  }

  getGrandTotals(): any {
    if (this._grandTotalsCache) return this._grandTotalsCache;
    this._grandTotalsCache = this.calculateGrandTotals();
    return this._grandTotalsCache;
  }

  // ✅ एकूण मार्च अखेर = sum of ALL weekly booking amounts in table
  calculateTotalMarchEnd(data: any): number {
    const months = ['april', 'may', 'june', 'july', 'august', 'september',
                    'october', 'november', 'december', 'january', 'feb', 'march'];
    let total = 0;
    for (const month of months) {
      for (let w = 1; w <= 5; w++) {
        const weekNum = w === 1 ? '1st' : w === 2 ? '2nd' : w === 3 ? '3rd' : w === 4 ? '4th' : '5th';
        total += parseFloat(data[`${month}${weekNum}WeekAmt`]) || 0;
      }
    }
    return total;
  }

  // ✅ THE KEY FIX:
  // आज अखेर वापरले = actual paid invoice amount from backend
  // NOT calculated from Sunday dates — that was causing wrong amounts
  calculateUsedTillToday(data: any): number {
    return parseFloat(data['aaj_akher_vaprle']) || 0;
  }

  calculateRemainingTillMarch(data: any): number {
    return this.calculateTotalMarchEnd(data) - this.calculateUsedTillToday(data);
  }

  calculateForNextYear(data: any): number {
    if (data.is_previous_contract === true) {
      const remaining    = parseFloat(data['contract_prev_bal'])  || 0;
      const usedTillToday = this.calculateUsedTillToday(data);
      return Math.max(0, remaining - usedTillToday);
    }

    const totalContractValue =
      (parseFloat(data['contract_prev_bal'])  || 0) +
      (parseFloat(data['contract_net_total']) || 0);

    const totalUsed  = this.calculateTotalMarchEnd(data);
    const remaining  = totalContractValue - totalUsed;
    return remaining > 0 ? remaining : 0;
  }

  calculateGroupTotals(group: any): any {
    let totalMarchEnd = 0, totalNextYear = 0, totalUsedTillToday = 0;

    for (const data of group.data) {
      totalMarchEnd       += this.calculateTotalMarchEnd(data);
      totalNextYear       += this.calculateForNextYear(data);
      totalUsedTillToday  += this.calculateUsedTillToday(data);
    }

    return {
      totalMarchEnd,
      totalNextYear,
      totalUsedTillToday,
      totalRemaining: totalMarchEnd - totalUsedTillToday
    };
  }

  calculateGrandTotals(): any {
    let contract_prev_bal = 0, contract_amt = 0, contract_discnt_amt = 0;
    let contract_net_amt = 0, contract_net_gst_amt = 0, contract_net_total = 0;
    let totalMarchEnd = 0, totalNextYear = 0, totalUsedTillToday = 0;

    for (const group of this.indetailsData) {
      contract_prev_bal    += parseFloat(group.contract_prev_bal)    || 0;
      contract_amt         += parseFloat(group.contract_amt)         || 0;
      contract_discnt_amt  += parseFloat(group.contract_discnt_amt)  || 0;
      contract_net_amt     += parseFloat(group.contract_net_amt)     || 0;
      contract_net_gst_amt += parseFloat(group.contract_net_gst_amt) || 0;
      contract_net_total   += parseFloat(group.contract_net_total)   || 0;

      for (const data of group.data) {
        totalMarchEnd      += this.calculateTotalMarchEnd(data);
        totalNextYear      += this.calculateForNextYear(data);
        totalUsedTillToday += this.calculateUsedTillToday(data);
      }
    }

    return {
      contract_prev_bal, contract_amt, contract_discnt_amt,
      contract_net_amt, contract_net_gst_amt, contract_net_total,
      totalMarchEnd, totalNextYear, totalUsedTillToday,
      totalRemaining: totalMarchEnd - totalUsedTillToday
    };
  }
}